import React  from 'react';
import { RadioChangeEvent } from 'antd/lib/radio/interface';
import { PricedStatus } from 'types';

import { RadioGroup } from '@bettercomp/ui-components';

export const PRICING_OPTIONS = {
  all: { value: PricedStatus.ALL, label: 'All' },
  priced: { value: PricedStatus.PRICED, label: 'Priced' },
  unpriced: { value: PricedStatus.UNPRICED, label: 'Unpriced' },
};

export const PRICING_OPTIONS_MASS = {
  all: { value: PricedStatus.ALL, label: 'All' },
  priced: { value: PricedStatus.PRICED, label: 'Priced' },
  noCuts: { value: PricedStatus.NO_CUTS, label: 'No Cuts' },
};

type PricingStatusSelectorProps = {
  isMass?: boolean,
  value?: PricedStatus,
  onChange: (value: PricedStatus) => void,
  containerClassName?: string,
}

export function PricingStatusSelector({ isMass,onChange, ...props }: PricingStatusSelectorProps) {
  const handleChange = (_event: RadioChangeEvent, value: PricedStatus) => {
    onChange(value);
  };

  return (
    <div data-testid="pricingStatusSelector">
      <RadioGroup
        options={Object.values(isMass ? PRICING_OPTIONS_MASS : PRICING_OPTIONS)}
        onChange={handleChange}
        {...props}
      />
    </div>
  );
}
